import React, { FC } from 'react';
import { Dialog, DialogContent } from '@shadcn/ui/components/ui/dialog';
import { PlaybooksGrid } from './playbooks-grid';
import { PlaybooksViewProvider } from '../hooks/use-playbooks-view';
import { PlaybookForm } from './playbook-form';
import { usePlaybookManagement } from '../../../hooks/use-playbook-management';

interface PlaybooksModalProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
}

// Create a context to override navigation within the modal
export const ModalNavigationContext = React.createContext<{
    navigateToPlaybook: (id: string) => void;
    navigateToNew: () => void;
    navigateBack: () => void;
} | null>(null);

export const PlaybooksModal: FC<PlaybooksModalProps> = ({ open, onOpenChange }) => {
    const {
        shouldShowModal,
        isModalOpen,
        currentView,
        editingPlaybookId,
        navigateToPlaybook,
        navigateToNew,
        navigateBack,
        closeModal,
    } = usePlaybookManagement();

    const navigationContextValue = {
        navigateToPlaybook,
        navigateToNew,
        navigateBack,
    };

    return (
        shouldShowModal && (
            <Dialog open={open} onOpenChange={onOpenChange}>
                <DialogContent className="w-[calc(100vw-2rem)] max-w-4xl max-h-[80vh] p-0 flex flex-col">
                    <ModalNavigationContext.Provider value={navigationContextValue}>
                        {currentView === 'grid' ? (
                            <div className="overflow-y-auto flex-1">
                                <PlaybooksViewProvider>
                                    <PlaybooksGrid />
                                </PlaybooksViewProvider>
                            </div>
                        ) : (
                            <div className="overflow-y-auto flex-1">
                                <PlaybookForm groupId={editingPlaybookId} />
                            </div>
                        )}
                    </ModalNavigationContext.Provider>
                </DialogContent>
            </Dialog>
        )
    );
};
